import React from 'react';
import { Field, RadioGroup } from '../../../Core';
import { ListFieldSection } from '../../../Layout';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { WorksheetEquipmentDropdown } from '../../Core';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let PreparationDrySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector = undefined }) => {
  const materialOvenDried = useSelector(
    pipe(createWorksheetSelector!('Preparation.MaterialDriedBy'), (d) => d === 'Oven')
  );
  const showGuardSieve = useSelector(
    pipe(createWorksheetSelector!('Preparation.GuardSieveUsed'), valueOrDefault(false))
  );
  const guardSieveSize = useSelector(createWorksheetSelector!('Preparation.GuardSieveSize'), deepEquals);
  const oversizeSieveSize = useSelector(createWorksheetSelector!('Preparation.OversizeSieveSize'), deepEquals);

  const materialRemovedByOptions = [
    {
      id: 'drySieving',
      label: `Dry Sieving over ${oversizeSieveSize.Caption} Sieve`,
      value: `Dry Sieving over ${oversizeSieveSize.Caption} sieve`,
    },
    {
      id: 'washing',
      label: `Washing over ${oversizeSieveSize.Caption} Sieve`,
      value: `Washing over ${oversizeSieveSize.Caption} sieve`,
    },
  ];
  const selectedMaterialRemovedBy = useSelector(
    pipe(createWorksheetSelector!('Preparation.OversizeMaterialRemovedBy'), (materialRemovedBy) =>
      materialRemovedByOptions.find((o) => o.value === materialRemovedBy)
    )
  );

  return (
    <>
      <ListFieldSection heading="Dry Preparation">
        <Field
          input={<RadioGroup />}
          label="Material Dried By"
          name="Preparation.MaterialDriedBy"
          options={[
            { label: 'Air Drying', value: 'Air' },
            { label: 'Oven Drying', value: 'Oven' },
          ]}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="Oven"
          equipmentType="oven"
          name="Preparation.Oven"
          visible={materialOvenDried}
        />
        <Field
          input={<RadioGroup />}
          label="Oversize Material Removed By"
          name="Preparation.OversizeMaterialRemovedBy"
          options={materialRemovedByOptions}
        />
        <Field
          input={<RadioGroup />}
          label="Coarser Sieve Used Over No. 40 (425µm) Sieve"
          name="Preparation.GuardSieveUsed"
          visible={selectedMaterialRemovedBy?.id === 'washing'}
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="Guard Sieve"
          equipmentType="sieve"
          name="Preparation.GuardSieve"
          visible={showGuardSieve && selectedMaterialRemovedBy?.id === 'washing'}
          queryParams={{ SieveSize: `${guardSieveSize?.Size.value} ${guardSieveSize?.Size.uom}` }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          label={`${oversizeSieveSize.Caption} sieve`}
          equipmentType="sieve"
          name="Preparation.OversizeSieve"
          queryParams={{ SieveSize: `${oversizeSieveSize?.Size.value} ${oversizeSieveSize?.Size.uom}` }}
        />
      </ListFieldSection>
    </>
  );
};

PreparationDrySection = withInjectedProps(PreparationDrySection);

export { PreparationDrySection };
export default PreparationDrySection;
